import { useCallback, useEffect, useState } from "react";
import SlideshowsList from "./SlideshowsList";
import PresentationTab from "./PresentationTab";
import SlidePreview from "./SlidePreview";
import '../styles/Presentation.css';
import { useRest } from "react-common";

const Presentation = () => {

    const [activeSlideshowID, setActiveSlideshowID] = useState();
    const [presentedSlide, setPresentedSlide] = useState();
    const [attendeeData, setAttendeeData] = useState();
    const { getData } = useRest();

    const getAttendeeData = useCallback(() => {
        getData("AttendeeData", {
            presentedSlideID: presentedSlide.id,
        })
            .then((result) => {
                setAttendeeData(result.records)
            })
            .catch(err => {
                console.log(err)
            })
    }, [getData, presentedSlide])

    useEffect(() => {
        if(presentedSlide){
            getAttendeeData()
        }
    }, [presentedSlide, getAttendeeData])

    return (
        <div className="presentationsContainer">
            <div className="slideshowListContainer">
                <SlideshowsList 
                    activeSlideshowID={activeSlideshowID}
                    setActiveSlideshowID={setActiveSlideshowID}
                />    
            </div>
            

            {activeSlideshowID &&
                <div className="presentationTabContainer">
                    <PresentationTab 
                        activeSlideshowID={activeSlideshowID}
                        presentedSlide={presentedSlide}
                        setPresentedSlide={setPresentedSlide}
                    />    
                </div>
            }  

            {presentedSlide &&
                <div className="slideContainer">
                    <SlidePreview
                        type={presentedSlide.slide.type}
                        slideConfiguration={presentedSlide.slide.configuration}
                        results={attendeeData}
                    />    
                </div>    
            }  
        </div>
        
    )
}

export default Presentation;